import { render, staticRenderFns } from "./PushConfigList.vue?vue&type=template&id=487189ef"
import script from "./PushConfigList.vue?vue&type=script&lang=js"
export * from "./PushConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports